import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Image from '../BuildingBlocks/Image';
import Text from '../BuildingBlocks/Text';
import VerticalSpacing from '../Utility/VerticalSpacing';
import Grid from '../Utility/Grid';
import CollapsePanel from '../CollapsePanel';
import Adaptive from '../Adaptive';
import { StyledGridCol } from './Affiliations.styles';

class Affiliations extends Component {
  static propTypes = {
    /** Section title */
    title: PropTypes.string,
    /** Text visible in 'show all' button */
    openText: PropTypes.node,
    /** Text visible in 'hide' button */
    closeText: PropTypes.node,
    /** array of img information */
    content: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        src: PropTypes.string,
        name: PropTypes.string
      })
    ),
    /** How many amenities are visible by default on md/lg/xl */
    visibleOnMedium: PropTypes.number,
    /** How many amenities are visible by default on xs/sm */
    visibleOnSmall: PropTypes.number
  };

  static defaultProps = {
    title: 'Affiliation',
    openText: 'See all',
    closeText: 'See less',
    content: [],
    visibleOnMedium: 3,
    visibleOnSmall: 2
  };

  constructor(props) {
    super(props);

    this.state = {};

    this.renderAffiliations = this.renderAffiliations.bind(this);
  }

  renderAffiliations(visible) {
    const { content } = this.props;

    const visibleItems = content.slice(0, visible);
    let hiddenItems = content.slice(visible, content.length);

    // zero out hiddenItems just so it doesn't get a duplicate one
    if (visible >= content.length) {
      hiddenItems = null;
    }

    const affiliateLayout = child => (
      <StyledGridCol key={child.id} xs={6} md={4}>
        <Image ratio="2:1" src={child.src} alt={child.name} />
      </StyledGridCol>
    );

    const visibleList = visibleItems.map(a => affiliateLayout(a));

    let hiddenList = null;

    if (hiddenItems !== null) {
      hiddenList = hiddenItems.map(a => affiliateLayout(a));
    }

    return { visibleList, hiddenList };
  }

  render() {
    const { title, openText, closeText, visibleOnMedium, visibleOnSmall } = this.props;

    const medAff = this.renderAffiliations(visibleOnMedium);
    const smallAff = this.renderAffiliations(visibleOnSmall);
    return (
      <VerticalSpacing size="sm">
        <Text.HeadingFourth tagName="h3">{title}</Text.HeadingFourth>
        <Grid.Row>
          <Adaptive sm={smallAff.visibleList} md={medAff.visibleList} />
        </Grid.Row>

        <Adaptive
          sm={
            smallAff.hiddenList ? (
              <CollapsePanel openText={openText} closeText={closeText}>
                <Grid.Row>{smallAff.hiddenList}</Grid.Row>
              </CollapsePanel>
            ) : (
              // Can't be empty
              ''
            )
          }
          md={
            medAff.hiddenList ? (
              <CollapsePanel openText={openText} closeText={closeText}>
                <Grid.Row>{medAff.hiddenList}</Grid.Row>
              </CollapsePanel>
            ) : (
              // Had to replace the content from sm with something or it would show the small content here
              <span />
            )
          }
        />
      </VerticalSpacing>
    );
  }
}

export default Affiliations;
